import React from "react"
import StripeForm from "./StripeForm"
import moment from "moment"
import { connect } from "react-redux"
import { createSubscription, closeSubModal } from "./actions"

const mapStateToProps = (state, ownProps) => {
  const user = state.models.user
  return {
    modalTitle: "Everlance Premium",
    buttonTitle: state.subs.trial_period_days
      ? `Start ${moment
          .duration(state.subs.trial_period_days, "day")
          .humanize()} Free Trial`
      : "Subscribe",
    buttonTitleSubmitting: "Subscribing...",
    couponField: true,
    totalField: true,
    potentialCredits: user.potential_credits,
    email: user.email,
    isGroup: !!user.group_as_enterprise_owner,
    form: state.ui.createSubscriptionForm,
    quantity: 1,
    ...state.subs
  }
}

const NewStripeForm = connect(
  mapStateToProps,
  {
    onCancel: closeSubModal,
    onReceiveStripeCardToken: createSubscription
  }
)(StripeForm)

export default NewStripeForm



// WEBPACK FOOTER //
// ./src/subscriptions/NewStripeForm.js